/**
 * AI Provider for React Native Mobile App
 * Integrates Apollo GraphQL client with AI services
 */

import React from 'react';
import { logger } from '../utils/logger';
import {
  AIApolloProvider,
  NetworkStatusIndicator,
  ApolloErrorBoundary,
} from '@coffeeplexity/api-client';

interface AIProviderProps {
  children: React.ReactNode;
}

export function AIProvider({ children }: AIProviderProps) {
  const handleError = (error: any) => {
    logger.error('AI Service Error:', error);
    // Could integrate with crash reporting service here
  };

  const handleNetworkStatusChange = (isOnline: boolean) => {
    logger.log('Network status changed:', isOnline ? 'online' : 'offline');
    // Could show toast notifications here
  };

  return (
    <AIApolloProvider
      config={{
        uri:
          process.env['EXPO_PUBLIC_GRAPHQL_ENDPOINT'] ||
          'http://localhost:8000/graphql',
        enableOfflineCache: true,
        enableRetry: true,
        maxRetryAttempts: 3,
        retryDelay: 1000,
        enablePersistedQueries: true,
      }}
      onError={handleError}
      onNetworkStatusChange={handleNetworkStatusChange}
    >
      <ApolloErrorBoundary>
        <NetworkStatusIndicator />
        {children}
      </ApolloErrorBoundary>
    </AIApolloProvider>
  );
}
